export interface LoginFormValues {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface OrganisationFormValues {
  name: string;
}

export interface ClientFormValues {
  id?: string;
  name: string;
  email: string;
  organisationId: string;
  workspaceName?: string;
}

// use to generically define the form values for various forms with key and secret
export interface UsernamePasswordFormValues {
  username: string;
  password: string;
  isValid: boolean;
}

export interface UsernamePasswordClientFormValues {
  client: string;
  username: string;
  password: string;
  isValid: boolean;
}

export interface GroupsFormValues {
  id?: string;
  selectedGroupIds: string[];
  groups: Group[];
}

export interface Group {
  id: string;
  name: string;
}

export interface Organisation {
  id: string;
  name: string;
  clientNr: number;
  createdAt: string;
}

export interface Client {
  id: string;
  name: string;
  email: string;
  organisationId: string;
  accessGroups: string[];
  connections: Connection[];
  resourcesInfo: ResourcesInfo | undefined;
  viewDeployments?: ViewDeployment[];
}

export interface ResourcesInfo {
  workspaceId: string;
  workspaceName: string;
  pipelineId: string;
}

export interface ViewDeployment {
  connectionType: string;
  deployedTimestampUtc: string;
  message: string;
}

export enum ActionType {
  OPEN = "open",
  FETCH = "fetch",
}

export enum SyncType {
  FULL = "full",
  DELTA = "delta"
}

export enum ComponentColorMode {
  LIGHT = "light",
  DARK = "dark",
}

export interface Organisation {
  id: string;
  name: string;
  clientNr: number;
}

export interface OrganisationFormValues {
  name: string;
}

export interface FortnoxActivationPayload {
  clientId: string;
  scopes: string[];
}

export interface FortnoxActivationResponse {
  activationUrl: string;
  activationLinkId?: string;
}

export interface ActivationLinkMailPayload {
  email: string;
}

export enum ConnectionStatus {
  OK = 1,
  Failed = 2,
}

export interface Connection {
  id: string;
  identifier: string;
  type: ConnectionType;
  status: ConnectionStatus;
  triggeredTimestampUtc: string;
  metadata?: { [key: string]: string };
  clientId: string;
}

export enum ConnectionType {
  Fortnox = 1,
  Next = 2,
  FileServer = 3,
  SDF = 4,
  Meltano_Shopify = 5,
}

export interface JobStatus {
  id: string;
  clientId: string;
  clientName: string;
  isFullSync: boolean;
  step: JobStep;
  statusMessage: string;
  started: string;
  updated: string;
  transformationJobLocation: string;
  transformationPercentage: number;
  errorMessage: string;
  hasError: boolean;
  fetchJobs: FetchJob[];
}

export enum JobStep {
  Queued = 0,
  Fetch = 1,
  Transformation = 2,
  Done = 3,
}

export interface FetchJob {
  id: string;
  connectionId: string;
  connectionName: string;
  percentage: number;
  started?: string | null;
  updated?: string | null;
  statusMessage: string;
  errorMessage: string;
  hasError: boolean;
  jobStatusId: string;
  jobStatus: JobStatus;
}

export enum BreadcrumbType {
  Organisations = "Organisations",
  Clients = "Clients"
}

export interface BreadcrumbItem {
  id: string;
  type: BreadcrumbType;
  name?: string;
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}

export interface Versions {
  api: string,
  notebook: NotebookCommitInfo
}

interface NotebookCommitInfo {
  date: string,
  sha: string
}